import { useState } from "react";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { PageHeader } from "@/components/common/PageHeader";
import { useAuth } from "@/auth/useAuth";
import { PaymentsTab } from "@/pages/finance/tabs/PaymentsTab";
import { ExpensesTab } from "@/pages/finance/tabs/ExpensesTab";
import { DebtsTab } from "@/pages/finance/tabs/DebtsTab";

function currentPeriod(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function CashboxPage() {
  const { hasPermission } = useAuth();
  const [tab, setTab] = useState(hasPermission("fin.payments") ? "payments" : hasPermission("fin.expense.entry") ? "expenses" : "debts");
  const [period, setPeriod] = useState(currentPeriod());

  const tabs = [
    { key: "payments", label: "Приходы", show: hasPermission("fin.payments") },
    { key: "expenses", label: "Расходы", show: hasPermission("fin.expense.entry") },
    { key: "debts", label: "Задолженности", show: hasPermission("fin.debts") },
  ].filter((t) => t.show);

  return (
    <>
      <PageHeader title="Касса" subtitle="Приходы, расходы и задолженности филиала. Сводная аналитика — у директора и бухгалтера." />
      <Paper className="crm-page-filter" variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Stack direction="row" spacing={1.5}>
          <TextField label="Период" type="month" size="small" InputLabelProps={{ shrink: true }} value={period} onChange={(e) => setPeriod(e.target.value)} />
        </Stack>
      </Paper>
      <Paper className="crm-workspace-panel" variant="outlined">
        <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable">
          {tabs.map((t) => <Tab key={t.key} value={t.key} label={t.label} />)}
        </Tabs>
        <Box p={3}>
          {tab === "payments" && <PaymentsTab period={period} />}
          {tab === "expenses" && <ExpensesTab />}
          {tab === "debts" && <DebtsTab />}
        </Box>
      </Paper>
    </>
  );
}
